(function initBooking() {
  const config = JSON.parse(document.querySelector("#BookingConfig").innerHTML)
  const data = JSON.parse(document.querySelector("#BookingData").innerHTML)

  const { date_from, date_to, exclude_weekdays, exclude_dates, timeslots, timeslot_size } = config
  const locale = navigator.language

  function getDatesBetween(start, end) {
    const dates = []
    let cur = new Date(start)
    const last = new Date(end)
    while (cur <= last) {
      dates.push(cur.toISOString().split("T")[0])
      cur.setDate(cur.getDate() + 1)
    }
    return dates
  }

  function isFullyBooked(day) {
    const booked = data[day] || {}
    return timeslots.every(ts => (booked[ts] || 0) >= timeslot_size)
  }

  const allDates = getDatesBetween(date_from, date_to)
  const enabledDates = allDates.filter(day => {
    const wd = new Date(day).toLocaleDateString("en-US", { weekday: "long" })
    if (exclude_weekdays.includes(wd)) return false
    if (exclude_dates.includes(day)) return false
    if (isFullyBooked(day)) return false
    return true
  })

  const fp = flatpickr("#product-booking-date-input", {
    dateFormat: "Y-m-d",
    enable: enabledDates,
    onChange(selectedDates, dateStr) {
      renderTimeslots(dateStr)
    }
  })

  const timeSelect = document.querySelector("#product-booking-time-input")
  
  function renderTimeslots(day) {
    timeSelect.removeAttribute("disabled")
    timeSelect.classList.remove("disabled")
    
    const booked = data[day] || {}
    const availableTimeslots = timeslots.filter(ts => (booked[ts] || 0) < timeslot_size)
    const items = availableTimeslots.map(ts => {
      return {
        raw: ts,
        label: new Date(`1970-01-01T${ts}:00`).toLocaleTimeString(navigator.language, { hour: "2-digit", minute: "2-digit" })
      }
    })

    timeSelect.querySelectorAll("option").forEach(el => el.value && el.remove())
        
    for (const {raw, label} of items) {
      const remaining = timeslot_size - (booked[raw] || 0)
      timeSelect.innerHTML += `<option value="${ raw }">${ label } (${remaining} left)</option>`
    }

  }

  const formId = document.querySelector(`#product-booking-date-input`).form.getAttribute("id")
  console.log(formId)
  const form = document.querySelector(`#${formId}`)
  form.addEventListener("submit", e => {
    const date = document.querySelector("#product-booking-date-input").value
    const time = document.querySelector("#product-booking-time-input").value
    const quantity = parseInt(document.querySelector(`[name='quantity'][form="${formId}"]`).value, 10) || 1
    const booked = data[date] || {}
    const available = timeslot_size - (booked[time] || 0)
  
    if (!date || !time) {
      alert("Please select a date from the calendar.")
      e.preventDefault()
      e.stopImmediatePropagation()
    } else if (quantity > available) {
      alert(`Only ${available} seats left for the selected timeslot.`)
      e.preventDefault()
      e.stopImmediatePropagation()
    }
  }, true)

})();
